import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { Box, Typography, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, Dialog, DialogTitle, DialogContent, DialogActions, Switch, IconButton, InputAdornment, MenuItem, Select, FormControl, InputLabel, FormControlLabel, CircularProgress } from '@mui/material';
import PaginacionControl from '../components/PaginacionControl';
import Autocomplete from '@mui/material/Autocomplete';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { GridOn } from '@mui/icons-material';
import SearchIcon from '@mui/icons-material/Search';
import TravelExploreIcon from '@mui/icons-material/Explore';
import CloseIcon from '@mui/icons-material/Close';
import SaveIcon from '@mui/icons-material/Save';
import { exportGenericWorkbook } from '../utils/excel/genericWorkbook';

const initialForm = {
  tipo: 'CLIENTE',
  tipo_documento_identidad_id: '',
  numero_documento: '',
  razon_social: '',
  nombres: '',
  apellidos: '',
  nombre_comercial: '',
  direccion: '',
  ubigeo: '',
  telefono: '',
  email: '',
  contacto: '',
  telefono_contacto: '',
  email_contacto: '',
  condicion_pago: '',
  dias_credito: '',
  limite_credito: '',
  observaciones: '',
  activo: true,
  agente_retencion: false,
  agente_detraccion: false
};

export default function Auxiliares() {
  const [auxiliares, setAuxiliares] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(initialForm);
  const [editing, setEditing] = useState(null);
  const [search, setSearch] = useState('');
  const [tiposDoc, setTiposDoc] = useState([]);
  const [loadingSunat, setLoadingSunat] = useState(false);
  const [errorSunat, setErrorSunat] = useState('');
  const [ubigeos, setUbigeos] = useState([]);
  const [condicionesPago, setCondicionesPago] = useState([]);
  const [ubigeoInput, setUbigeoInput] = useState('');
  const [ubigeoSeleccionado, setUbigeoSeleccionado] = useState(null);
  const tableRef = useRef();

  useEffect(() => {
    fetchAuxiliares();
    fetchTiposDoc();
    fetchCondicionesPago();
  }, []);

  const fetchAuxiliares = async () => {
    const res = await axios.get('/api/auxiliares');
    setAuxiliares(res.data);
    setFiltered(res.data);
  };
  const fetchTiposDoc = async () => {
    const res = await axios.get('/api/tipo-documento-identidad');
    setTiposDoc(res.data);
  };
  const fetchCondicionesPago = async () => {
    const res = await axios.get('/api/condicion-pago');
    setCondicionesPago(res.data);
  };

  useEffect(() => {
    if (!search) {
      setFiltered(auxiliares);
    } else {
      setFiltered(
        auxiliares.filter(aux =>
          (aux.numero_documento || '').toLowerCase().includes(search.toLowerCase()) ||
          (aux.razon_social || '').toLowerCase().includes(search.toLowerCase()) ||
          (aux.nombres || '').toLowerCase().includes(search.toLowerCase()) ||
          (aux.apellidos || '').toLowerCase().includes(search.toLowerCase()) ||
          (aux.email || '').toLowerCase().includes(search.toLowerCase())
        )
      );
    }
  }, [search, auxiliares]);

  const handleOpen = async (aux = null) => {
    setEditing(aux);
    if (aux && aux.id) {
      // Siempre obtener los datos completos del backend
      try {
        const { data: auxFull } = await axios.get(`/api/auxiliares/${aux.id}`);
        const safeForm = { ...initialForm, ...auxFull };
        Object.keys(safeForm).forEach(k => {
          if (safeForm[k] === null || safeForm[k] === undefined) {
            safeForm[k] = initialForm[k];
          }
        });
        if (auxFull.condicion_pago_obj && auxFull.condicion_pago_obj.id) {
          safeForm.condicion_pago = auxFull.condicion_pago_obj.id;
        }
        setForm(safeForm);
        // Cargar objeto ubigeo si hay código
        if (auxFull.ubigeo) {
          try {
            const res = await axios.get(`/api/ubigeo/${auxFull.ubigeo}`);
            if (res.data && res.data.codigo) {
              setUbigeoSeleccionado(res.data);
              setUbigeoInput(`${res.data.departamento}, ${res.data.provincia}, ${res.data.distrito} (${res.data.codigo})`);
            } else {
              setUbigeoSeleccionado(null);
              setUbigeoInput('');
            }
          } catch {
            setUbigeoSeleccionado(null);
            setUbigeoInput('');
          }
        } else {
          setUbigeoSeleccionado(null);
          setUbigeoInput('');
        }
      } catch {
        setForm(initialForm);
        setUbigeoSeleccionado(null);
        setUbigeoInput('');
      }
    } else if (!aux) {
      setForm(initialForm);
      setUbigeoSeleccionado(null);
      setUbigeoInput('');
    }
    setOpen(true);
    setErrorSunat('');
  };
  const handleClose = () => {
    setOpen(false);
    setEditing(null);
    setErrorSunat('');
    setLoadingSunat(false);
  };
  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    setForm({ ...form, [name]: type === 'checkbox' ? checked : value });
  };
  const UBIGEO_LIMA_CODIGO = '150101';
  const seleccionarUbigeoLima = async () => {
    let u = { codigo: UBIGEO_LIMA_CODIGO, departamento: 'LIMA', provincia: 'LIMA', distrito: 'LIMA' };
    try {
      const res = await axios.get(`/api/ubigeo/${UBIGEO_LIMA_CODIGO}`);
      if (res.data?.codigo) u = res.data;
    } catch {}
    setUbigeoSeleccionado(u);
    setUbigeoInput(`${u.departamento}, ${u.provincia}, ${u.distrito} (${u.codigo})`);
    setForm(f => ({ ...f, ubigeo: u.codigo }));
  };
  const handleSave = async () => {
    if (!form.numero_documento?.toString().trim()) { alert('El número de documento es obligatorio.'); return; }
    if (!form.razon_social?.trim() && !form.nombres?.trim()) { alert('La razón social o nombre es obligatorio.'); return; }
    const ubigeoFinal = form.ubigeo?.toString().trim() || (String(form.tipo_documento_identidad_id) === '1' ? UBIGEO_LIMA_CODIGO : '');
    if (!ubigeoFinal) { alert('El ubigeo (departamento / provincia / distrito) es obligatorio para emitir comprobantes electrónicos.'); return; }
    // Filtrar solo los campos permitidos por el backend
    const allowed = [
      'tipo', 'tipo_documento_identidad_id', 'numero_documento', 'razon_social', 'nombres', 'apellidos', 'nombre_comercial', 'direccion', 'ubigeo', 'telefono', 'email', 'contacto', 'telefono_contacto', 'email_contacto', 'condicion_pago', 'dias_credito', 'limite_credito', 'observaciones', 'estado', 'condicion', 'activo', 'usuario_registro', 'usuario_actualizacion', 'agente_retencion', 'agente_detraccion'
    ];
    const data = {};
    allowed.forEach(k => {
      if (form[k] !== undefined) data[k] = form[k];
    });
    data.ubigeo = ubigeoFinal;
    data.direccion = form.direccion?.toString().trim() || '-';
    try {
      if (editing) {
        await axios.put(`/api/auxiliares/${editing.id}`, data);
      } else {
        await axios.post('/api/auxiliares', data);
      }
      fetchAuxiliares();
      setOpen(false);
    } catch (err) {
      alert(err.response?.data?.error || 'Error al guardar');
    }
  };
  const handleDelete = async id => {
    try {
      await axios.delete(`/api/auxiliares/${id}`);
      fetchAuxiliares();
    } catch { alert('Error al eliminar'); }
  };
  const handleActive = async (aux, activo) => {
    try {
      await axios.put(`/api/auxiliares/${aux.id}`, { ...aux, activo });
      fetchAuxiliares();
    } catch { }
  };
  const exportExcel = async () => {
    const rows = filtered.map(a => ({
      id: a.id,
      tipo: a.tipo || '',
      numero_documento: a.numero_documento || '',
      razon_social: a.razon_social || '',
      nombres: a.nombres || '',
      apellidos: a.apellidos || '',
      direccion: a.direccion || '',
      telefono: a.telefono || '',
      email: a.email || '',
      estadoStr: a.activo ? 'Activo' : 'Inactivo'
    }));
    await exportGenericWorkbook({
      titulo: 'REPORTE DE AUXILIARES (CLIENTES / PROVEEDORES)',
      sheetName: 'Auxiliares',
      tableName: 'tblAuxiliares',
      fileName: 'Auxiliares',
      columns: [
        { key: 'id', label: 'ID', width: 8 },
        { key: 'tipo', label: 'Tipo', width: 14 },
        { key: 'numero_documento', label: 'Nro Documento', width: 16 },
        { key: 'razon_social', label: 'Razón Social', width: 30 },
        { key: 'nombres', label: 'Nombres', width: 20 },
        { key: 'apellidos', label: 'Apellidos', width: 20 },
        { key: 'direccion', label: 'Dirección', width: 28 },
        { key: 'telefono', label: 'Teléfono', width: 16 },
        { key: 'email', label: 'Email', width: 24 },
        { key: 'estadoStr', label: 'Estado', width: 12, isEstado: true }
      ],
      rows,
      searchText: search,
      usuario: ''
    });
  };
  // Consulta RUC/DNI
  const handleBuscarSunat = async () => {
    setErrorSunat('');
    setLoadingSunat(true);
    try {
      // Asegura que tipo sea string y compara con '1' (DNI) o '6' (RUC)
      let tipo = (form.tipo_documento_identidad_id || '').toString().trim();
      // Si el tipo es un número, conviértelo a string
      if (tipo === '6' || tipo === 6) tipo = '6';
      else if (tipo === '1' || tipo === 1) tipo = '1';
      let numero = (form.numero_documento || '').toString().trim();
      let url = '';
      if (tipo === '1' && numero.length === 8) {
        url = `/api/consulta-peru/dni/${numero}`;
      } else if (tipo === '6' && numero.length === 11) {
        url = `/api/consulta-peru/ruc/${numero}`;
      } else {
        setErrorSunat('Tipo/Número de documento no válido para consulta.');
        setLoadingSunat(false);
        return;
      }
      const res = await axios.get(url);
      if (res.data && res.data.success) {
        if (tipo === '1') {
          setForm(f => ({
            ...f,
            nombres: res.data.nombres || '',
            apellidos: [res.data.apellidoPaterno, res.data.apellidoMaterno].filter(Boolean).join(' '),
            razon_social: '',
            nombre_comercial: '',
            direccion: '',
          }));
          if (!form.ubigeo) await seleccionarUbigeoLima();
        } else if (tipo === '6') {
          // Llenar campos de SUNAT
          setForm(f => ({
            ...f,
            razon_social: res.data.razonSocial || '',
            nombre_comercial: res.data.nombreComercial || res.data.razonSocial || '',
            direccion: res.data.direccion || '',
            nombres: '',
            apellidos: '',
            estado: res.data.estado || '',
            condicion: res.data.condicion || '',
          }));
          // Buscar y seleccionar ubigeo si existe
          if (res.data.ubigeo) {
            try {
              const ubigeoRes = await axios.get(`/api/ubigeo/${res.data.ubigeo}`);
              if (ubigeoRes.data && ubigeoRes.data.codigo) {
                setUbigeoSeleccionado(ubigeoRes.data);
                setForm(f => ({ ...f, ubigeo: ubigeoRes.data.codigo }));
                setUbigeoInput(`${ubigeoRes.data.departamento}, ${ubigeoRes.data.provincia}, ${ubigeoRes.data.distrito} (${ubigeoRes.data.codigo})`);
              } else {
                setUbigeoSeleccionado(null);
                setForm(f => ({ ...f, ubigeo: '' }));
                setUbigeoInput('');
              }
            } catch {
              setUbigeoSeleccionado(null);
              setForm(f => ({ ...f, ubigeo: '' }));
              setUbigeoInput('');
            }
          } else {
            setUbigeoSeleccionado(null);
            setForm(f => ({ ...f, ubigeo: '' }));
            setUbigeoInput('');
          }
        }
      } else {
        setErrorSunat(res.data && res.data.message ? res.data.message : 'No se encontraron datos.');
      }
    } catch (err) {
      setErrorSunat('Error consultando SUNAT/RENIEC.');
    }
    setLoadingSunat(false);
  };
  // Autocomplete ubigeo eficiente
  const handleUbigeoInput = async (e, value) => {
    setUbigeoInput(value);
    if (value && value.length >= 2) {
      try {
        const res = await axios.get(`/api/ubigeo?q=${encodeURIComponent(value)}`);
        setUbigeos(res.data);
      } catch {
        setUbigeos([]);
      }
    } else {
      setUbigeos([]);
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 1, mb: 4, width: '100%' }}>
      <Box sx={{ width: { xs: '100%', sm: '95%', md: '90%' }, maxWidth: 1800 }}>
        <Typography variant="h4" gutterBottom sx={{ textAlign: { xs: 'center', md: 'left' }, mb: 3, fontWeight: 'bold', color: '#222' }}>
          Auxiliares (Clientes, Proveedores, Otros)
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, mb: 2 }}>
          <TextField
            label="Buscar"
            value={search}
            onChange={e => { setSearch(e.target.value); setPage(0); }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <SearchIcon />
                </InputAdornment>
              )
            }}
            size="small"
            sx={{ flex: 1 }}
          />
          <Button variant="contained" color="success" startIcon={<GridOn />} sx={{ minWidth: 120 }} onClick={exportExcel}>
            Exportar Excel
          </Button>
          <Button variant="contained" color="primary" startIcon={<AddIcon />} onClick={() => handleOpen()} sx={{ ml: { xs: 0, sm: 'auto' }, mt: { xs: 2, sm: 0 } }}>
            Nuevo Auxiliar
          </Button>
          <TextField
            size="small"
            label="Mostrar"
            type="number"
            value={rowsPerPage}
            onChange={e => { setRowsPerPage(Number(e.target.value)); setPage(0); }}
            sx={{ width: 100 }}
          />
        </Box>
        <TableContainer component={Paper} sx={{ borderRadius: 4, boxShadow: '0 4px 24px rgba(0,0,0,0.08)', mt: 2, overflowX: 'auto' }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="center" sx={{ pr: 8 }}>Tipo</TableCell>
                <TableCell align="center">Tipo Doc.</TableCell>
                <TableCell align="center">N° Documento</TableCell>
                <TableCell align="center">Razón Social / Nombre</TableCell>
                <TableCell align="center">Email</TableCell>
                <TableCell align="center">Teléfono</TableCell>
                <TableCell align="center">Activo</TableCell>
                <TableCell align="center">Acciones</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filtered.slice(rowsPerPage === -1 ? 0 : page * rowsPerPage, rowsPerPage === -1 ? undefined : (page + 1) * rowsPerPage).map(aux => (
                <TableRow key={aux.id}>
                  <TableCell align="center" sx={{ pr: 8 }}>{aux.tipo}</TableCell>
                  <TableCell align="center">{aux.tipo_documento_desc || aux.tipo_documento_codigo || aux.tipo_documento_identidad_id}</TableCell>
                  <TableCell align="center">{aux.numero_documento}</TableCell>
                  <TableCell align="center">{aux.razon_social || (aux.nombres + ' ' + aux.apellidos)}</TableCell>
                  <TableCell align="center">{aux.email}</TableCell>
                  <TableCell align="center">{aux.telefono}</TableCell>
                  <TableCell align="center">
                    <Switch
                      checked={!!aux.activo}
                      color="success"
                      onChange={e => handleActive(aux, e.target.checked)}
                    />
                  </TableCell>
                  <TableCell align="center">
                    <IconButton color="primary" onClick={() => handleOpen(aux)}>
                      <EditIcon />
                    </IconButton>
                    <IconButton color="error" onClick={() => handleDelete(aux.id)}>
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <PaginacionControl page={page} rowsPerPage={rowsPerPage} count={filtered.length} onPageChange={setPage} />
      </Box>
      <Dialog open={open} onClose={(_, r) => r !== 'backdropClick' && handleClose()} disableEscapeKeyDown={false} maxWidth="md" fullWidth>
        <DialogTitle>
          <Typography variant="h5" fontWeight="bold">
            {editing ? 'Editar' : 'Nuevo'} Auxiliar
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Box display="flex" flexDirection="column" alignItems="stretch" width="100%" sx={{ mt: 1.5 }}>
            {/* ...existing code... */}
            <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2 }}>
              <Autocomplete
                options={["CLIENTE", "PROVEEDOR", "OTRO"]}
                value={form.tipo || "CLIENTE"}
                onChange={(_e, value) => setForm(f => ({ ...f, tipo: value || "CLIENTE" }))}
                disableClearable
                sx={{ width: '100%' }}
                renderInput={params => (
                  <TextField {...params} label="Tipo" margin="dense" fullWidth />
                )}
              />
              <Autocomplete
                options={tiposDoc}
                getOptionLabel={option => option.descripcion || ''}
                value={tiposDoc.find(td => td.codigo === form.tipo_documento_identidad_id) || null}
                onChange={(_e, value) => setForm(f => ({ ...f, tipo_documento_identidad_id: value ? value.codigo : '' }))}
                isOptionEqualToValue={(option, value) => option.codigo === value.codigo}
                sx={{ width: '100%' }}
                renderInput={params => (
                  <TextField {...params} label="Tipo Doc." margin="dense" fullWidth />
                )}
              />
            </Box>
            <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2}}>
              <TextField
                label="N° Documento"
                name="numero_documento"
                value={form.numero_documento}
                onChange={handleChange}
                margin="dense"
                sx={{ flex: '0 0 25%' }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={handleBuscarSunat} disabled={loadingSunat || !form.numero_documento} edge="end" title="Buscar SUNAT/RENIEC">
                        {loadingSunat ? <CircularProgress size={20} /> : <TravelExploreIcon />}
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
              <TextField label="Razón Social" name="razon_social" value={form.razon_social} onChange={handleChange} margin="dense" sx={{ flex: '1 1 75%' }} />
            </Box>
            {errorSunat && (
              <Typography color="error" variant="body2">{errorSunat}</Typography>
            )}
            <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2 }}>
              <TextField label="Nombre Comercial" name="nombre_comercial" value={form.nombre_comercial} onChange={handleChange} fullWidth margin="dense" sx={{ flex: 4 }} />
              <TextField label="Nombres" name="nombres" value={form.nombres} onChange={handleChange} fullWidth margin="dense" sx={{ flex: 3 }} />
              <TextField label="Apellidos" name="apellidos" value={form.apellidos} onChange={handleChange} fullWidth margin="dense" sx={{ flex: 3 }} />
            </Box>
            <TextField label="Dirección" name="direccion" value={form.direccion} onChange={handleChange} fullWidth margin="dense" />
            <Autocomplete
              options={ubigeos}
              getOptionLabel={option => {
                if (!option) return '';
                if (option.departamento && option.provincia && option.distrito) {
                  return `${option.departamento}, ${option.provincia}, ${option.distrito} (${option.codigo})`;
                }
                return option.codigo || '';
              }}
              value={ubigeoSeleccionado}
              inputValue={ubigeoInput}
              onInputChange={handleUbigeoInput}
              onChange={(_e, value) => {
                setUbigeoSeleccionado(value);
                setForm(f => ({ ...f, ubigeo: value ? value.codigo : '' }));
                setUbigeoInput(value ? `${value.departamento}, ${value.provincia}, ${value.distrito} (${value.codigo})` : '');
              }}
              isOptionEqualToValue={(option, value) => option && value && option.codigo === value.codigo}
              filterOptions={(x) => x}
              sx={{ width: '100%' }}
              renderInput={params => (
                <TextField {...params} label="Ubigeo (departamento / provincia / distrito) *" variant="outlined" fullWidth margin="dense"
                  error={!form.ubigeo}
                  helperText={!form.ubigeo ? 'Requerido para comprobantes electrónicos' : ''}
                />
              )}
            />
            <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2 }}>
              <TextField label="Teléfono" name="telefono" value={form.telefono} onChange={handleChange} margin="dense" sx={{ flex: 2 }} />
              <TextField label="Email" name="email" value={form.email} onChange={handleChange} margin="dense" sx={{ flex: 4 }} />
              <TextField label="Contacto" name="contacto" value={form.contacto} onChange={handleChange} margin="dense" sx={{ flex: 4 }} />
            </Box>
            <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2 }}>
              <TextField label="Tel. Contacto" name="telefono_contacto" value={form.telefono_contacto} onChange={handleChange} margin="dense" sx={{ flex: 2 }} />
              <TextField label="Email Contacto" name="email_contacto" value={form.email_contacto} onChange={handleChange} margin="dense" sx={{ flex: 4 }} />
              <FormControl sx={{ flex: 4 }}>
                <Autocomplete
                  options={condicionesPago}
                  getOptionLabel={option => option.descripcion || ''}
                  value={condicionesPago.find(cp => cp.id === form.condicion_pago) || null}
                  onChange={(_e, value) => setForm(f => ({ ...f, condicion_pago: value ? value.id : '' }))}
                  isOptionEqualToValue={(option, value) => option.id === value.id}
                  renderInput={params => (
                    <TextField {...params} label="Condición Pago" margin="dense" fullWidth />
                  )}
                />
              </FormControl>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2 }}>
              <TextField label="Días Crédito" name="dias_credito" value={form.dias_credito} onChange={handleChange} type="number" margin="dense" sx={{ flex: 2 }} />
              <TextField label="Límite Crédito" name="limite_credito" value={form.limite_credito} onChange={handleChange} type="number" margin="dense" sx={{ flex: 2 }} />
              <TextField label="Observaciones" name="observaciones" value={form.observaciones} onChange={handleChange} margin="dense" sx={{ flex: 6 }} />
            </Box>
            <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 1 }}>
              <FormControlLabel control={<Switch checked={!!form.activo} onChange={handleChange} name="activo" color="success" />} label="Activo" />
              <FormControlLabel control={<Switch checked={!!form.agente_retencion} onChange={handleChange} name="agente_retencion" color="warning" />} label="Agente de Retención" />
              <FormControlLabel control={<Switch checked={!!form.agente_detraccion} onChange={handleChange} name="agente_detraccion" color="warning" />} label="Sujeto a Detracción" />
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} startIcon={<CloseIcon />} variant="contained" color="error">Cancelar</Button>
          <Button onClick={handleSave} startIcon={<SaveIcon />} variant="contained" color="primary">Guardar</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
